export default __webpack_public_path__ + "static/media/Cross.2359ef1a.svg";